export const maskEmail = (email: string): string => {
  if (!email || !email.includes("@")) return "";

  const [localPart, domain] = email.split("@");

  if (!localPart || localPart.length <= 3) {
    return `${localPart?.[0] ?? ""}***@${domain ?? ""}`;
  }

  const visibleStart = localPart.slice(0, 2);
  const visibleEnd = localPart.slice(-1);
  const maskedMiddle = "*".repeat(localPart.length - 3);

  return `${visibleStart}${maskedMiddle}${visibleEnd}@${domain}`;
};
